import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { speakToAConsultantService } from "./speakToAConsultant.service";

const initialState = {
  speakToAConsultantSentSuccess: false,
  loading: false,
};

export const sendSpeakToAConsultant = createAsyncThunk(
  "/speakToAConsultant/saveClientDetails",
  async (data, thunkAPI) => {
    const response = await speakToAConsultantService.saveClientDetails(data);
    return response.data;
  }
);

export const speakToAConsultantSlice = createSlice({
  name: "speakToAConsultant",
  initialState,
  reducers: {
    resetSpeakToAConsultantSuccess: (state) => {
      state.speakToAConsultantSentSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendSpeakToAConsultant.fulfilled, (state) => {
        state.loading = false;
        state.speakToAConsultantSentSuccess = true;
      })
      .addCase(sendSpeakToAConsultant.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendSpeakToAConsultant.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { resetSpeakToAConsultantSuccess } =
  speakToAConsultantSlice.actions;
export default speakToAConsultantSlice.reducer;
